import { render, staticRenderFns } from "./LogsAcesso.vue?vue&type=template&id=1899f24e&scoped=true&"
import script from "./logsAcesso.js?vue&type=script&lang=js&"
export * from "./logsAcesso.js?vue&type=script&lang=js&"
import style0 from "./LogsAcesso.vue?vue&type=style&index=0&id=1899f24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899f24e",
  null
  
)

export default component.exports